import { Box, keychaine, useColorModeValue as mode, useDisclosure } from '@chaine/keychaine';
import React from 'react';
import { Marker as ReactMapGLMarker } from 'react-map-gl';
import { AvailableLoadPopup } from './available-load-popup/available-load-popup';
import { formatPrice } from './available-load-popup/freight-rate-tag';
const AvailableLoadMarker = (props) => {
    const { id, index, loadDetails, preventPopupsOnHover = false, coordinates, openOnRender } = props;
    const { isOpen, onOpen, onClose } = useDisclosure();
    const onHandleMouseEnter = (event) => {
        event.preventDefault();
        onOpen();
    };
    const onHandleMouseLeave = (event) => {
        event.preventDefault();
        onClose();
    };
    return (React.createElement(React.Fragment, null,
        isOpen && !preventPopupsOnHover && (React.createElement(Box, { sx: {
                '.mapboxgl-popup-content': {
                    borderRadius: '12px',
                    borderWidth: '1px',
                    borderColor: '#21262d',
                    background: '#21262d',
                    '-webkit-backdrop-filter': 'blur(10px)',
                    'backdrop-filter': 'blur(10px)'
                }
            } },
            React.createElement(AvailableLoadPopup, { coordinates: coordinates, loadDetails: loadDetails }))),
        openOnRender && (React.createElement(Box, { sx: {
                '.mapboxgl-popup-content': {
                    borderRadius: '12px',
                    borderWidth: '1px',
                    borderColor: '#21262d',
                    background: '#21262d',
                    '-webkit-backdrop-filter': 'blur(10px)',
                    'backdrop-filter': 'blur(10px)'
                }
            } },
            React.createElement(AvailableLoadPopup, { coordinates: coordinates, loadDetails: loadDetails }))),
        React.createElement(ReactMapGLMarker, { key: `${id}-${index}-available-load-marker`, latitude: coordinates?.latitude || 0, longitude: coordinates?.longitude || 0 },
            React.createElement(keychaine.span, { onMouseEnter: onHandleMouseEnter, onMouseLeave: onHandleMouseLeave },
                React.createElement(Box, { "aria-label": "stop-marker", width: '100%', height: 5, py: 3, px: '6px', borderRadius: 12, backgroundColor: mode('white', 'gray.900'), borderColor: mode('border.tertiary', 'gray.600'), borderWidth: 0.8, boxShadow: mode('2px 2px 4px 0px rgba(0, 0, 0, 0.25)', 'dark-lg'), color: 'text.primary', display: "flex", alignItems: "center", justifyContent: 'center', fontWeight: "semibold", fontSize: "xs" }, formatPrice(loadDetails.rate))))));
};
const AvailableLoadMarkers = (props) => {
    const { id, loads, preventPopupsOnHover = false, openAvailableLoadOnRender = false } = props;
    return (React.createElement(Box, null, (loads || []).map((load, index) => {
        const loadDetails = load?.loadDetails;
        const coordinates = load?.coordinates;
        const openOnRender = index === 2 && openAvailableLoadOnRender ? true : false;
        if (!coordinates?.latitude || !coordinates?.longitude) {
            return React.createElement(keychaine.span, { key: index });
        }
        return (React.createElement(AvailableLoadMarker, { id: id, preventPopupsOnHover: preventPopupsOnHover, index: index, key: index, loadDetails: loadDetails, coordinates: coordinates, openOnRender: openOnRender }));
    })));
};
AvailableLoadMarkers.displayName = 'AvailableLoadMarkers';
export { AvailableLoadMarkers };
